import { createWebHistory, createRouter } from 'vue-router'
import barkerAuth from '@/auth'

const routes = [
  { name: 'account', path: '/account', component: () => import('@/views/AccountView.vue') },
  { name: 'home', path: '/home', component: () => import('@/views/HomeView.vue') },
  { name: 'help', path: '/about', component: () => import('@/views/HelpView.vue') },
  { name: 'landing', path: '/', component: () => import('@/views/LandingView.vue') },
  { name: 'login', path: '/login', component: () => import('@/views/LandingView.vue') },
  { name: 'logout', path: '/logout', component: () => import('@/views/LandingView.vue') },
  {
    path: '/module',
    component: () => import('@/views/ModuleView.vue'),
    children: [
      {
        name: 'data-manager',
        path: 'data-manager',
        component: () => import('@/views/DataManager.vue'),
        props: true,
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

const anonymousPaths = [
  'login',
  'logout',
  'signup',
  'help',
]

router.beforeEach(async (to /*, from */) => {
  // If not logged in and trying to access a path that requires login, go to login screen.
  if(!barkerAuth.isLoggedIn() && !anonymousPaths.includes(to.name)){
    return {
      name: 'login',
      query: {
        redirect: to.fullPath,
      }
    }
  }
  // If logged in, go to home instead of login screen.
  if(to.name == 'login'){
    if(barkerAuth.isLoggedIn()){
      return {name: 'home'}
    }
  }
  // If logging out, clear local data.
  if(to.name == 'logout'){
    barkerAuth.logout()
  }
  // Set title.
  document.title = "TritonX"
})

export default router